__turbopack_context__.v({
  "background": "styles-module__yeyFSq__background",
  "container": "styles-module__yeyFSq__container",
  "mounted": "styles-module__yeyFSq__mounted",
  "visible": "styles-module__yeyFSq__visible",
});
